import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
type LayoutProps = {
  children: React.ReactNode;
};

/** Shared page shell: skip link, navigation, main landmark, contact + footer. */
export function Layout({
  children
}: LayoutProps) {
  return <>
      <a href="#main" className="skip-link" data-id="element-133" data-mp="uyb9pwqjslqp">
        Skip to content
      </a>
      <Navbar data-id="element-134" data-mp="uw89kjvolc89" />
      <main id="main" data-id="element-135" data-mp="78qf2gl1801l">{children}</main>
      <Footer data-id="element-136" data-mp="79s3dmr26j19" />
    </>;
}